import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Web Growth Studio | Expert Web Design & Social Media Management',
  description = 'Transform your online presence with Web Growth Studio. Specializing in custom website design, development, and social media management for businesses.',
  keywords = 'web design, website development, social media management, Instagram marketing, Facebook ads, website redesign',
  image = 'https://webgrowthstudio.com/og-image.jpg',
  url = 'https://webgrowthstudio.com',
  type = 'website'
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
